import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const userDetails = async () => {
  const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.getUserDetails()}`;
  const res = await fetch(url);

  if (!res.ok) {
    return { error:true, message: 'User details request failed', status: res.status, data: [] };
  }
  const getData = await res.json();
  return { status: res.status, data: getData };
};

export default userDetails;
